import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { FormDoc } from 'src/app/core/models/physician/form-doc';
import { FormService } from 'src/app/core/services/v2/form.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { FormFolder } from '../../../core/models/physician/form-folder';

@Component({
  selector: 'app-form-folder-view',
  templateUrl: './form-folder-view.component.html',
  styleUrls: ['./form-folder-view.component.scss']
})
export class FormFolderViewComponent implements OnChanges{
  displayedColumns: string[] = ['title', 'code', 'summary','creationDate','action'];
  dataSource:any;
  @Input() formFolder: FormFolder;
  @Input() isTemplate: boolean;
  @Output() ReloadListOfFolder = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  //dataSource = new MatTableDataSource<FormDoc>([]);

  constructor(private formService: FormService, private loaderService: WindowLoaderService,
    private cdr: ChangeDetectorRef, private _router: Router) { }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource<FormDoc>(this.formFolder.forms.reverse());
    this.dataSource.paginator = this.paginator;

    this.cdr.detectChanges();

  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  OnReloadListOfFolder(v:any){
    this.ReloadListOfFolder.emit(v);
  }
  //this.dialog.open(AddPdfformComponent);
  inactive(frmId: number) {
    //this.errorMessage = "";
    if (frmId && frmId > 0) {
      this.loaderService
        .blockWithLoader(this.formService.deleteForm(frmId))
        .subscribe(
          (templ) => {
            if (templ.resultStatus.isSuccess) {
              //this.formGroupList.splice(ind, 1);
              this.ReloadListOfFolder.emit(true)
            } else {
              console.error(templ.resultStatus);
            }
          },
          (error) => {
            console.error(error);
            //this.errorMessage = "Folder could not be deleted";
          }
        );
    }
  }
  
    openFormPreview(formDoc) {
      this._router.navigate([`${this.formService.spaFormDetailsRoute}${formDoc.id}`]);
    }
}
